(function(){
  if(!document.getElementById('zf-btn'))return;
  document.getElementById('zf-btn').addEventListener('click',zfSearch);
  var zfCache=null;
  function zfFetch(cb){
    if(zfCache){cb(zfCache);return;}
    fetch('/collections/zentrierringe-felgenzentrierringe-premium/products.json?limit=250')
      .then(function(r){return r.json();})
      .then(function(d){zfCache=d.products||[];cb(zfCache);})
      .catch(function(){document.getElementById('zf-results').innerHTML='<p style="color:#c41e3a;padding:12px 0">Fehler beim Laden. Bitte Seite neu laden.</p>';});
  }
  function zfSearch(){
    var ad=document.getElementById('zf-ad').value;
    var id=document.getElementById('zf-id').value;
    var res=document.getElementById('zf-results');
    if(!ad||!id){res.innerHTML='<p style="color:#888;padding:12px 0;font-size:14px">&#9888; Bitte beide Durchmesser wählen.</p>';return;}
    res.innerHTML='<p style="color:#888;padding:12px 0;font-size:14px">Suche läuft…</p>';
    zfFetch(function(products){
      var matches=products.filter(function(p){
        var t=(p.tags||[]).join(',');
        return t.indexOf(ad)>-1&&t.indexOf(id)>-1;
      });
      if(!matches.length){
        res.innerHTML='<div style="padding:20px;background:#fff8f0;border:1px solid #ffe0b0;border-radius:8px;text-align:center"><p style="margin:0 0 12px;font-weight:600">Keine Kombination gefunden</p><p style="margin:0 0 16px;font-size:14px;color:#555">Für diese Maßkombination haben wir aktuell keinen Artikel.</p><a href="/collections/zentrierringe-felgenzentrierringe-premium" style="display:inline-block;background:#1a1a1a;color:#fff;padding:10px 20px;border-radius:6px;font-size:14px;font-weight:600;text-decoration:none">Alle Zentrierringe ansehen</a></div>';
        return;
      }
      var html='<div class="zfp-results-header">'+matches.length+' Zentrierring'+(matches.length>1?'e':'')+' gefunden</div>';
      matches.forEach(function(p){
        var img=p.images&&p.images.length>0
          ?'<img src="'+p.images[0].src+'" class="zfp-product-img" alt="'+p.title+'">'
          :'<div class="zfp-product-img-placeholder">&#9881;</div>';
        var v1=p.variants[0];
        var v2=p.variants.length>1?p.variants[1]:null;
        var price='1 Stück: <strong>CHF '+parseFloat(v1.price).toFixed(2)+'</strong>'+(v2?' | 4er-Set: <strong>CHF '+parseFloat(v2.price).toFixed(2)+'</strong>':'');
        html+='<div class="zfp-product-card">'+img+'<div class="zfp-product-info"><div class="zfp-product-title">'+p.title+'</div><div class="zfp-product-price">'+price+'</div><a href="/products/'+p.handle+'" class="zfp-product-link">Zum Produkt &#8594;</a></div></div>';
      });
      res.innerHTML=html;
    });
  }
})();